import * as React from 'react'
import { DiffEntry, formatDiffValue } from '@/modules/shared/utils/diff'

type CustomCellsProps = {
  renderDiff: NonNullable<DiffEntry['renderDiff']>
  before: unknown
  after: unknown
}

const DiffCustomCells: React.FC<CustomCellsProps> = ({ renderDiff, before, after }) => {
  const { before: beforeNode, after: afterNode } = renderDiff(before, after)
  return (
    <>
      <td className="tw-px-3 tw-py-2 tw-text-red-600">{beforeNode}</td>
      <td className="tw-px-3 tw-py-2 tw-font-semibold tw-text-green-700">{afterNode}</td>
    </>
  )
}

export const DiffView: React.FC<{ entries: DiffEntry[] }> = ({ entries }) => {
  if (!entries.length) return null

  return (
    <div className="tw-mt-3 tw-max-h-72 tw-overflow-y-auto tw-rounded tw-border tw-border-gray-200 tw-text-sm">
      <table className="tw-w-full tw-border-collapse">
        <thead className="tw-sticky tw-top-0 tw-bg-gray-50">
          <tr className="tw-border-b tw-border-gray-200 tw-text-xs tw-font-semibold tw-uppercase tw-text-gray-500">
            <th className="tw-px-3 tw-py-2 tw-text-left tw-w-[40%]">Pole</th>
            <th className="tw-px-3 tw-py-2 tw-text-left">Przed</th>
            <th className="tw-px-3 tw-py-2 tw-text-left">Po zmianie</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(({ key, label, before, after, format, renderDiff }) => (
            <tr key={key} className="tw-border-b tw-border-gray-100 last:tw-border-0 odd:tw-bg-white even:tw-bg-gray-50">
              <td className="tw-px-3 tw-py-2 tw-font-medium tw-text-gray-700">{label}</td>
              {renderDiff ? (
                <DiffCustomCells renderDiff={renderDiff} before={before} after={after} />
              ) : (
                <>
                  <td className="tw-px-3 tw-py-2 tw-text-red-600">
                    <span className="tw-line-through">{formatDiffValue(before, format)}</span>
                  </td>
                  <td className="tw-px-3 tw-py-2 tw-font-semibold tw-text-green-700">
                    {formatDiffValue(after, format)}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
